module.exports = __webpack_public_path__ + "static/media/calling-all-reactive-agents-1.8cc01226.jpg";